<ng-container *ngIf="name && name.length > 0">
  <ng-container *ngIf="imageUrl && imageUrl.length > 0">
    <img [src]="imageUrl" [alt]="name" class="districtImage"/>
  </ng-container>
  <ng-container *ngIf="!imageUrl || imageUrl.length === 0">
    {{ name }}
  </ng-container>
</ng-container>
